module.exports = __webpack_public_path__ + "static/img/img-3-7.23bcc3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-7.png
// module id = 2031
// module chunks = 0